<template>
  <v-card-title class="pa-0 mb-2">
    <v-toolbar :dense="dense">
      <slot name="prepend_actions"></slot>
      <v-toolbar-title>
        <slot name="title">
          {{title}}
        </slot>
      </v-toolbar-title>
      <v-spacer v-if="!hide_action_spacer"></v-spacer>
      <slot name="actions"></slot>

      <template v-if="extended" v-slot:extension>
        <slot name="extension"></slot>
      </template>
    </v-toolbar>
  </v-card-title>
</template>

<script>
export default {
name: "CardTitle",
  props:{
    title: {
      required: false,
      default: "Default Title"
    },
    hide_action_spacer: {
      default: false,
      type: Boolean,
    },
    extended: {
      default: false,
      type: Boolean,
    },
    dense: {
      default: false,
      type: Boolean,
    }
  }
}
</script>

<style scoped>

</style>
